import React, { useState, useEffect, useRef } from 'react';
import DynamicIcon from './dynamic-icon';

const PrimarySearch = ({ placeholder, onSearch, additionalclasses, disabled, onFocus, onBlur, onKeyDown, shouldFocus, defaultValue, type='text', hideIcon =false, enableShortcut = false }) => {
    const [searchValue, setSearchValue] = useState(defaultValue || '');

    const handleChange = (e) => {
        const value = e.target.value;
        setSearchValue(value);
        { onSearch && onSearch(value); }
    };

    const inputRef = useRef(null);

    useEffect(() => {
        if (shouldFocus && inputRef.current) {
            setTimeout(() => {
                inputRef.current.focus();
            }, 100);
        }
        if (enableShortcut) {
            const handleKeyDown = (e) => {
                if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'f') {
                    e.preventDefault();
                    inputRef.current.focus();
                }
            };

            document.addEventListener('keydown', handleKeyDown);
            return () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [shouldFocus]);

    return (
        <div className={`lg:w-[418px] h-[40px] rounded-[10px] custom-bg-white-200 px-[12px] flex items-center gap-[12px] text-[14px] poppins-regular leading-[21px] placeholder-grey-200 dark:placeholder-grey-dark-200 custom-text-grey-900 ${additionalclasses}`}>
            {!hideIcon && <DynamicIcon name='search' size={18} />}
            <input
                ref={inputRef}
                type={type}
                placeholder={placeholder}
                className='w-full outline-none bg-[transparent]'
                value={searchValue}
                onChange={handleChange}
                disabled={disabled}
                onFocus={onFocus}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
            />
            {/* <DynamicIcon name='list-filter' size={18} /> */}
        </div>
    );
};

export default PrimarySearch;